/*
 * KATVR 共通 動画 autoplay kicker
 *
 * 目的:
 *   Shopify の <video autoplay muted playsinline> は autoplay 属性だけでは
 *   Chrome/Safari の autoplay policy にブロックされて再生されないことがある。
 *   特に Safari は canplay 前の play() を reject する・重い preload は失敗する。
 *
 * 方針:
 *   1. ページ内の autoplay 付き <video> を全部拾う（動的に追加されるケースも対象）
 *   2. 表示中（display:none でない）かつ muted なものを対象に
 *      canplay 以降に v.play() を明示呼び出し
 *   3. それでも弾かれた場合は初回のユーザ操作（touch/click/scroll/pointer）で再試行
 *   4. resize で媒体切替が起きたら再 kick
 *   5. Shopify のテーマエディタでセクション追加/選択されても再 kick
 *
 * 互換:
 *   - Chrome: 重い動画の多重 autoplay を弾く → 非表示側に play() を呼ばない（display:none スキップ）
 *   - Safari: canplay/loadeddata 待ち + load() 明示呼び出しで reject を回避
 *
 * hero-cinema など独自の play 管理を持つセクションとは共存可能（play() は冪等）。
 */
(function(){
  'use strict';

  var kicked = new WeakSet();

  function tryPlay(v){
    var p;
    try { p = v.play(); } catch(e){ p = null; }
    if(p && typeof p.catch === 'function'){
      p.catch(function(){
        if(kicked.has(v)) return;
        kicked.add(v);
        var retry = function(){
          try { v.play().catch(function(){}); } catch(e){}
          document.removeEventListener('touchstart', retry);
          document.removeEventListener('click', retry);
          document.removeEventListener('pointerdown', retry);
          document.removeEventListener('scroll', retry);
          document.removeEventListener('keydown', retry);
        };
        document.addEventListener('touchstart', retry, { passive: true, once: true });
        document.addEventListener('click', retry, { once: true });
        document.addEventListener('pointerdown', retry, { once: true });
        document.addEventListener('scroll', retry, { passive: true, once: true });
        document.addEventListener('keydown', retry, { once: true });
      });
    }
  }

  function kickOne(v){
    // autoplay 属性が無い動画は対象外（商品ギャラリーなど手動再生のもの）
    if(!v.autoplay) return;
    // muted が外れている動画は autoplay policy で必ず弾かれるのでスキップ
    if(!v.muted) return;
    var cs;
    try { cs = getComputedStyle(v); } catch(e){ cs = null; }
    if(cs && cs.display === 'none') return;

    if(v.readyState >= 3){ // HAVE_FUTURE_DATA 以上
      tryPlay(v);
    } else {
      var onReady = function(){ tryPlay(v); };
      v.addEventListener('canplay', onReady, { once: true });
      v.addEventListener('loadeddata', onReady, { once: true });
      // preload に関わらず再ロードを促す（Safari 対策）
      try { v.load(); } catch(e){}
    }
  }

  function kickAll(root){
    var scope = root || document;
    var vids = scope.querySelectorAll('video[autoplay]');
    for(var i = 0; i < vids.length; i++){ kickOne(vids[i]); }
  }

  // 初期起動
  function init(){ kickAll(document); }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // 全リソース読了後にも kick（Safari で DOM 描画完了タイミング保証）
  if(document.readyState !== 'complete'){
    window.addEventListener('load', function(){ kickAll(document); }, { once: true });
  }
  // リサイズで媒体切替が起きた場合にも再 kick（PC/SP video の出し分け）
  var resizeTimer = null;
  window.addEventListener('resize', function(){
    if(resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function(){ kickAll(document); }, 200);
  }, { passive: true });
  // テーマエディタ対応
  document.addEventListener('shopify:section:load', function(e){
    if(e && e.target) kickAll(e.target);
  });
  document.addEventListener('shopify:section:select', function(e){
    if(e && e.target) kickAll(e.target);
  });
})();
